import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop completed with undelivered notifications"
// warning. It's surfaced by the CRA dev-server error overlay but is harmless — it
// originates from shadcn Popover/Command measuring its own contents on open.
const RO_LOOP_MESSAGES = [
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
];
window.addEventListener("error", (e) => {
  if (e && e.message && RO_LOOP_MESSAGES.some((m) => e.message.includes(m))) {
    e.stopImmediatePropagation();
    e.preventDefault();
    // Hide the webpack-dev-server overlay if it rendered
    const overlay =
      document.getElementById("webpack-dev-server-client-overlay") ||
      document.querySelector("iframe[id^='webpack-dev-server']");
    if (overlay && overlay.style) overlay.style.display = "none";
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || String(e?.reason || "");
  if (RO_LOOP_MESSAGES.some((m) => msg.includes(m))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
